import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vehicle-select" }
const _hoisted_2 = { class: "selections" }
const _hoisted_3 = { class: "selections__vehicle" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { class: "quantity" }
const _hoisted_6 = {
  key: 0,
  class: "selections__vehicle"
}
const _hoisted_7 = { class: "quantity" }
const _hoisted_8 = {
  key: 0,
  class: "checkbox-container"
}
const _hoisted_9 = { class: "vehicle-selection__button" }

import { Direction } from "@/models/Enums";
import { getEmptyVehicleItem, useVehicleStore } from "@/store/vehicleStore";
import useVuelidate from "@vuelidate/core";
import { VBtn, VCheckbox, VModal, VQuantity } from "v-ferry-components";
import { computed, ref } from "vue";
import { VehicleItem } from "../../models/Vehicle";
import VehicleSelect from "./VehicleSelect.vue";

interface Props {
    hasReturn?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleForm',
  props: {
    hasReturn: { type: Boolean }
  },
  setup(__props: any) {



const showVehiclesModal = ref(false);

const vehicleStore = useVehicleStore();

const vehiclesPlaceholder = computed(() => vehicleStore.getVehiclesTotal);

const numberOfVehiclesOutward = ref(vehicleStore.getVehiclesOfRoute(Direction.Outward).length);

const numberOfVehiclesReturn = ref(vehicleStore.getVehiclesOfRoute(Direction.Return).length);

const vehiclesOutward = computed(() => vehicleStore.getVehiclesOfRoute(Direction.Outward));
const vehiclesReturn = computed(() => vehicleStore.getVehiclesOfRoute(Direction.Return));

const differentDetails = computed({
    get(): boolean {
        return vehicleStore.getDifferentDetails;
    },
    set(value: boolean) {
        vehicleStore.setDifferentDetails(value);
    },
});

const v$ = useVuelidate();

const outwardVehiclesRef = ref();

const returnVehiclesRef = ref();

const submitVehicles = async () => {
    const isValid = await v$.value.$validate();

    if (!isValid) return;
    if (!outwardVehiclesRef.value) {
        showVehiclesModal.value = false;
        return;
    }

    const outwardVehicles = outwardVehiclesRef.value.map((v: { state: VehicleItem }) => v.state);

    vehicleStore.setVehicles(Direction.Outward, outwardVehicles);

    if (differentDetails.value && returnVehiclesRef.value) {
        const returnVehicles = returnVehiclesRef.value.map((v: { state: VehicleItem }) => v.state);
        vehicleStore.setVehicles(Direction.Return, returnVehicles);
    } else if (differentDetails.value) {
        vehicleStore.setVehicles(Direction.Return, []);
    }

    showVehiclesModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VBtn), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showVehiclesModal.value = true)),
      type: "button",
      class: "dropdown-btn inputs__dropdown",
      color: "ghost"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(vehiclesPlaceholder.value), 1)
      ]),
      _: 1
    }),
    (showVehiclesModal.value)
      ? (_openBlock(), _createBlock(_unref(VModal), {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showVehiclesModal.value = false)),
          title: "Vehicles and bicycles"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "heading" }, [
                _createElementVNode("p", null, "Please note: Please be aware of any bike racks / roof racks that might affect the overall height of the vehicle."),
                _createElementVNode("p", null, "Commercial Vehicles must be booked via our Freight Department by calling 08001114434.")
              ], -1)),
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitVehicles, ["prevent"]),
                class: "vehicle-selection"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (differentDetails.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Outward"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                      _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Add vehicles and bicycles", -1)),
                      _createVNode(_unref(VQuantity), {
                        class: "quantity-input",
                        id: "vehicleSelect",
                        modelValue: numberOfVehiclesOutward.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((numberOfVehiclesOutward).value = $event)),
                        minValue: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfVehiclesOutward.value, (index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "vehicle"
                      }, [
                        _createVNode(VehicleSelect, {
                          ref_for: true,
                          ref_key: "outwardVehiclesRef",
                          ref: outwardVehiclesRef,
                          direction: _unref(Direction).Outward,
                          vehicleIndex: index,
                          vehicle: vehiclesOutward.value.length >= index ? vehiclesOutward.value[index - 1] : _unref(getEmptyVehicleItem)()
                        }, null, 8, ["direction", "vehicleIndex", "vehicle"])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.hasReturn && differentDetails.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "Return", -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Add vehicles and bicycles", -1)),
                          _createVNode(_unref(VQuantity), {
                            class: "quantity-input",
                            id: "vehicleSelect",
                            modelValue: numberOfVehiclesReturn.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((numberOfVehiclesReturn).value = $event)),
                            minValue: 0
                          }, null, 8, ["modelValue"])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numberOfVehiclesReturn.value, (index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "vehicle"
                          }, [
                            _createVNode(VehicleSelect, {
                              ref_for: true,
                              ref_key: "returnVehiclesRef",
                              ref: returnVehiclesRef,
                              direction: _unref(Direction).Return,
                              vehicleIndex: index,
                              vehicle: vehiclesReturn.value.length >= index ? vehiclesReturn.value[index - 1] : _unref(getEmptyVehicleItem)()
                            }, null, 8, ["direction", "vehicleIndex", "vehicle"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasReturn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_unref(VCheckbox), {
                        modelValue: differentDetails.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((differentDetails).value = $event)),
                        class: "checkbox",
                        id: "return"
                      }, null, 8, ["modelValue"]),
                      _cache[8] || (_cache[8] = _createElementVNode("span", null, "Different details for return", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(VBtn), null, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Add")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ])
              ], 32)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})